module.exports = __webpack_public_path__ + "static/media/shiveshresume.32e0852f.pdf";